<template>
  <div class="toolBar" v-if="showToolbar">
    <template v-for="item in items" :key="item.name">
      <template v-if="item.name === 'exportResults'">
        <button class="borderless" @click="item.fn">
          <IconFileSpreadsheet stroke="1" color="var(--primary)" size="21" />
        </button>
      </template>
      <template v-if="item.name === 'columnSettings'">
        <button class="borderless" @click="item.fn">
          <IconEyeCog stroke="1" color="var(--primary)" size="21" />
        </button>
      </template>
    </template>

    <div class="zoom">
      <button class="zoom borderless" @click="zoomOut()">
        <IconZoomOut stroke="1.25" size="20" color="var(--primary)" />
      </button>
      <button class="zoom borderless" @click="zoomIn()">
        <IconZoomIn stroke="1.25" size="20" color="var(--primary)" />
      </button>
    </div>
    <a
      v-if="techSupportURL"
      :href="techSupportURL"
      target="_blank"
      class="button borderless techSupport"
    >
      Assistência Técnica
    </a>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { IconZoomIn } from '@tabler/icons-vue'
import { IconZoomOut } from '@tabler/icons-vue'
import { IconFileSpreadsheet } from '@tabler/icons-vue'
import { IconEyeCog } from '@tabler/icons-vue'
import { axios } from '../../request'

export default {
  name: 'ToolBar',
  data() {
    return {
      fontSize: null,
      techSupportURL: null,
    }
  },
  components: { IconZoomIn, IconZoomOut, IconFileSpreadsheet, IconEyeCog },
  computed: {
    ...mapState({
      items: (state) => state.toolbar.items,
    }),
    ...mapGetters({
      orgType: 'settings/orgType',
    }),
    showToolbar() {
      let showToolbar = true
      if (['unpaidSingle'].includes(this.$route.name)) {
        showToolbar = false
      }
      return showToolbar
    },
    userRole() {
      if (typeof this.$store.state.auth.jwt.CustomUserInfo === 'undefined') {
        return null
      }
      return this.$store.state.auth.jwt.CustomUserInfo.Role
    },
    isAdminOrEditor() {
      return ['admin', 'editor'].includes(this.userRole)
    },
  },
  methods: {
    ...mapActions({
      setTablesNeedRefresh: 'toolbar/tablesNeedRefresh',
    }),
    zoomIn() {
      const fontValue = parseFloat(this.fontSize.match(/\d+/)[0])
      const fontUnit = this.fontSize.match(/\D+/)[0]
      const newSize = fontValue + 1

      this.setFontSize(newSize, fontUnit)
      this.setTablesNeedRefresh(true)
    },

    zoomOut() {
      const fontValue = parseFloat(this.fontSize.match(/\d+/)[0])
      const fontUnit = this.fontSize.match(/\D+/)[0]
      const newSize = fontValue - 1

      this.setFontSize(newSize, fontUnit)
      this.setTablesNeedRefresh(true)
    },

    setFontSize(value, unit) {
      if (value > 11 && value < 20) {
        const size = value + unit
        const root = document.documentElement
        root.style.setProperty('--main-font-size', size)
        this.fontSize = size
        localStorage.setItem('fontSize', size)
      }
    },
    setTechSupportURL() {
      if (this.isAdminOrEditor) {
        axios
          .get(`users/${this.$store.state.auth.jwt.CustomUserInfo.ID}`)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              if (typeof res.data.data !== 'undefined') {
                if (typeof res.data.data.email !== 'undefined') {
                  const email = res.data.data.email
                  const orgName = import.meta.env.VITE_TITLE
                  const username = this.$store.state.auth.jwt.CustomUserInfo.Name
                  const role = this.$store.state.auth.jwt.CustomUserInfo.Role
                  const magicString = '9GlKIRE9pSeXBJnEz4FqHu4Se6ebEtEz'
                  const orgType = this.orgType
                  const urlObj = { orgType, orgName, username, role, magicString, email }
                  const paramString = btoa(JSON.stringify(urlObj))
                  this.techSupportURL =
                    'https://tech-support.fimdomeio.com/?payload=' + encodeURIComponent(paramString)
                }
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        return false
      }
    },
  },
  created() {
    const root = document.documentElement
    const style = getComputedStyle(root)
    this.fontSize = style.getPropertyValue('--main-font-size')
    const savedSize = localStorage.getItem('fontSize')
    if (savedSize !== null) {
      const fontValue = parseFloat(savedSize.match(/\d+/)[0])
      const fontUnit = savedSize.match(/\D+/)[0]
      this.setFontSize(fontValue, fontUnit)
    }
    this.setTechSupportURL()
  },
}
</script>

<style scoped lang="scss">
.toolBar {
  padding-top: 3px;
  margin-right: 3px;
  display: flex;
  gap: calc(var(--sp) * 0.75);
  flex-grow: 1;
  justify-content: flex-end;
}
.zoom {
  display: flex;
  gap: calc(var(--sp) * 0.25);
  justify-content: flex-end;
  margin-top: 2px;
}
button:hover::before {
  background-color: transparent !important;
}

button {
  margin: 0;
  height: 30px !important;
  min-height: unset !important;
  padding: 0 !important;
  min-width: fit-content;
}
.techSupport {
  height: 2em;
  line-height: 1.5;
  margin: 0;
  color: var(--primary);
  font-size: 0.8rem;
  padding-top: 0;
  border: 1px solid var(--primary);
  padding-left: var(--sp) !important;
  padding-right: var(--sp) !important;
  padding-top: 3px;
  padding-bottom: 3px;
}
.techSupport:hover {
  background-color: var(--primary);
}
</style>
